import AnimationConstant from '@/constants/AnimationConstant'

const { MAX_FRAME_COUNT } = AnimationConstant

const mixin = {
  data: function () {
    return {
      timelineViewFrameRange: { min: 1, max: 31 },
      openKeyframeTimeline: true,
      animationKeyframes: [],
      isShiftingKeyframes: false,
      isDeletingKeyframes: false
    }
  },
  computed: {
    isKeyframeTimelineVisible () {
      return this.openKeyframeTimeline &&
        !(this.isPlayingAnimation || this.isApplyEstimateModal || this.isGeneratingAnimation) &&
        this.frameCountCache <= MAX_FRAME_COUNT
    }
  },
  watch: {
    isKeyframeTimelineVisible (val) {
      this.animationKeyframes = []
      if (val && this.enableAnimationFeatures) {
        this.unityRequestKeyframes()
      }
    }
  },
  methods: {
    onKeyframeTimelineOperation (isSuccessful) {
      const id = this._pendingTimelineOperationId
      this._pendingTimelineOperationId = 0

      const timeline = this.$refs.keyframeTimeline
      if (!timeline) { return }

      if (!isSuccessful) {
        timeline.revertOperation(id)
      }
    },
    onKeyframeRangeChange (range) {
      this.timelineViewFrameRange = range
    },
    updateKeyframeTimelineFrame (frame, count, cacheOnNextChange) {
      const timeline = this.$refs.keyframeTimeline
      if (!timeline) { return }

      if (count === 1) {
        this.timelineViewFrameRange = { min: frame, max: frame + 30 }
        this.$nextTick(() => timeline.syncFrameRange())
      }
      timeline.onEditorFrameIndex(frame - 1, cacheOnNextChange)
    },
    onActiveKeyframeIndex ({ id, frameIndex }) {
      // Assume success. Otherwise frame change should change frame active frame index.
      this.unityFocusFrameIndex(frameIndex)
      const timeline = this.$refs.keyframeTimeline
      timeline.revertOperation(id)
    },
    _isKeyframeOperationClear (id) {
      const timeline = this.$refs.keyframeTimeline

      if (this._pendingTimelineOperationId) {
        timeline.revertOperation(id)
        return false
      }

      this._pendingTimelineOperationId = id
      return true
    },
    onShiftKeyframes ({ id, deltaFrames, indexes }) {
      if (this._isKeyframeOperationClear(id)) {
        this.unityShiftKeyframes(deltaFrames, indexes)
      }
    },
    onDeleteKeyframes ({ id, indexes }) {
      if (this._isKeyframeOperationClear(id)) {
        this.unityDeleteKeyframes(indexes)
      }
    }
  }
}

export default mixin
